/**********************************************************************
 * CARROUSEL PRODUITS — DKpsuleur (VERSION PROPRE MULTI-SLIDERS)
 * --------------------------------------------------------------
 * ✔ Multi-collections support
 * ✔ Shuffle produits
 * ✔ Flèches custom PC
 * ✔ Flèches auto-désactivées si pas besoin de scroll (ex: 6/6)
 * ✔ Scroll mobile natif conservé
 * ✔ Aucun conflit Shopify
 **********************************************************************/

(function () {

  function isDesktop() {
    return window.innerWidth >= 1024;
  }

  if (window.location.pathname.includes('/collections/standard')) {
    return;
  }

  /* ==========================
     SHUFFLE PRODUITS
  ========================== */
  function shuffleProducts(container) {
    const products = Array.from(container.children);
    if (products.length <= 1) return;

    for (let i = products.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [products[i], products[j]] = [products[j], products[i]];
    }

    products.forEach(p => container.appendChild(p));

    const sliderWrapper = container.closest('.slider');
    if (sliderWrapper) {
      setTimeout(() => {
        sliderWrapper.dispatchEvent(new Event('resize'));
      }, 100);
    }
  }

  function tryShuffle() {
    const containers = document.querySelectorAll('ul.product-grid');
    if (!containers.length) return false;

    containers.forEach(container => {
      shuffleProducts(container);
    });

    return true;
  }

  /* ==========================
     NAVIGATION FLÈCHES CUSTOM
  ========================== */
  function addCarouselNavigation(container) {

    if (!isDesktop()) return;

    /* ✔ NE PAS afficher si pas de scroll nécessaire (ex: 6/6) */
    const scrollNeeded = container.scrollWidth > container.clientWidth;
    if (!scrollNeeded) return;

    const parent = container.parentNode;

    const wrapper = document.createElement('div');
    wrapper.style.position = 'relative';
    wrapper.style.display = 'flex';
    wrapper.style.flexDirection = 'column';
    wrapper.style.alignItems = 'center';

    parent.insertBefore(wrapper, container);
    wrapper.appendChild(container);

    container.style.overflowX = 'hidden';
    container.style.scrollBehavior = 'smooth';
    container.style.display = 'flex';
    container.style.gap = '1rem';

    /* ================= flèche factory ================= */
    function createBtn(side) {
      const btn = document.createElement('button');

      /* ✔ Flèches propres (plus de < >) */
      btn.innerHTML = side === 'left' ? '←' : '→';

      btn.style.position = 'absolute';
      btn.style.zIndex = '10';
      btn.style.background = 'rgba(0,0,0,0.36)';
      btn.style.color = '#fff';
      btn.style.border = 'none';
      btn.style.cursor = 'pointer';
      btn.style.fontSize = '1.5rem';
      btn.style.width = '45px';
      btn.style.height = '45px';
      btn.style.borderRadius = '6px';
      btn.style.display = 'flex';
      btn.style.alignItems = 'center';
      btn.style.justifyContent = 'center';
      btn.style.transition = 'background 0.3s';

      btn.onmouseenter = () => btn.style.background = 'rgba(0,0,0,0.8)';
      btn.onmouseleave = () => btn.style.background = 'rgba(0,0,0,0.36)';

      btn.style.top = `${container.offsetHeight + 18}px`;

      if (side === 'left') {
        btn.style.left = '5%';
        btn.style.transform = 'translateX(-100%)';
      } else {
        btn.style.left = '95%';
        btn.style.transform = 'translateX(0)';
      }

      return btn;
    }

    const btnLeft = createBtn('left');
    const btnRight = createBtn('right');

    wrapper.appendChild(btnLeft);
    wrapper.appendChild(btnRight);

    const scrollStep =
      container.children[0]?.offsetWidth +
      parseInt(getComputedStyle(container).gap || 0);

    btnLeft.addEventListener('click', () => {
      container.scrollBy({ left: -scrollStep, behavior: 'smooth' });
    });

    btnRight.addEventListener('click', () => {
      container.scrollBy({ left: scrollStep, behavior: 'smooth' });
    });

    window.addEventListener('resize', () => {
      btnLeft.style.top = `${container.offsetHeight + 18}px`;
      btnRight.style.top = `${container.offsetHeight + 18}px`;
    });
  }

  /* ==========================
     INIT MULTI-CARROUSEL
  ========================== */
  function initCarousel() {
    const containers = document.querySelectorAll('ul.product-grid');

    containers.forEach(container => {
      addCarouselNavigation(container);
    });
  }

  /* ==========================
     START
  ========================== */
  window.addEventListener('load', () => {

    if (!tryShuffle()) {
      let attempts = 0;

      const interval = setInterval(() => {
        if (tryShuffle() || attempts >= 10) {
          clearInterval(interval);
          initCarousel();
        }
        attempts++;
      }, 500);

    } else {
      initCarousel();
    }

  });

})();